import React, { useEffect, useState, useCallback } from "react";
import Marquee from "react-fast-marquee";
import { Modal, Button, Textarea, Spinner } from "flowbite-react";
import Backend from "../../../Backend/Backend";
import toast from "react-hot-toast";
import useSize from "../../../Utils/useSize/useSize";

const backend = await new Backend().init();

export default function MarqueeComponent() {
  const windowSize = useSize();
  const userType = Number(localStorage.getItem("user_type") || 7);
  const [marquee, setMarquee] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [newText, setNewText] = useState("");
  const [loading, setLoading] = useState(false);

  /** ✅ Load Marquee Text */
  const loadMarquee = useCallback(async () => {
    try {
      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
      };

      const r = await backend.marquee(data);

      if (r.error === "False") setMarquee(r.marquee.text || "");
      else toast.error(r.message);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load marquee.");
    }
  }, []);

  /** ⏳ Load marquee on mount */
  useEffect(() => {
    loadMarquee();
  }, [loadMarquee]);

  /** ⎋ Close modal with ESC */
  useEffect(() => {
    const handleEsc = (e) => e.key === "Escape" && setShowModal(false);
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  /** ✏️ Handle marquee update */
  const handleUpdate = async () => {
    if (!newText.trim()) return toast.error("Please enter marquee text.");

    setLoading(true);
    try {
      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        msg: newText,
      };

      const r = await backend.update_marquee(data);

      if (r.error === "False") {
        setMarquee(newText);
        toast.success("Marquee updated successfully!");
        setShowModal(false);
      } else toast.error(r.message);
    } catch (err) {
      console.error(err);
      toast.error("Failed to update marquee.");
    } finally {
      setLoading(false);
    }
  };

  /** ✏️ Handle marquee update */
  const handleRemove = async () => {
    if (!newText.trim()) return toast.error("Please enter marquee text.");

    setLoading(true);
    try {
      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        remove : "1"
      };

      const r = await backend.update_marquee(data);

      if (r.error === "False") {
        setMarquee(newText);
        toast.success("Marquee updated successfully!");
        setShowModal(false);
      } else toast.error(r.message);
    } catch (err) {
      console.error(err);
      toast.error("Failed to update marquee.");
    } finally {
      setLoading(false);
    }
  };

  /** 🚀 ENTER KEY to submit */
  const handleKeyPress = (e) => {
    if (!showModal) return;

    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault(); // prevent new line
      handleUpdate(); // call update
    }
  };

  /** 🖌️ Theme-friendly class for dynamic backgrounds */
  const bgClass = "bg-[var(--background)] text-[var(--text)]";

  return (
    <div
      onClick={() => {
        if (showModal) return;
        if (
          userType === 1 ||
          userType === 2 ||
          userType === 3 ||
          userType === 5 ||
          userType === 6
        ) {
          setNewText(marquee);
          setShowModal(true);
        }
      }}
      className="cursor-pointer select-none"
    >
      <Marquee
        speed={50}
        pauseOnHover
        gradient={false}
        style={{
          width: windowSize[0] / 6,
        }}
        className="font-semibold text-[var(--text)] large text-base px-3"
      >
        {marquee || "No marquee text available"}
      </Marquee>

      {/* ✅ Edit Modal */}
      <Modal
        show={showModal}
        size="md"
        onClose={() => setShowModal(false)}
        theme={{
          root: { base: `border-[var(--primary)]` },
        }}
      >
        <Modal.Header className={bgClass}>Edit Marquee Text</Modal.Header>

        <Modal.Body className={bgClass}>
          <Textarea
            className={`${bgClass} focus:ring-[var(--primary)]`}
            value={newText}
            onChange={(e) => setNewText(e.target.value)}
            rows={3}
            placeholder="Enter new marquee text..."
            onKeyDown={handleKeyPress} // 👈 ENTER support
          />
        </Modal.Body>

        <Modal.Footer className={bgClass}>
          <Button
            onClick={handleUpdate}
            disabled={loading}
            className="min-w-[100px] bg-[var(--primary)] text-[var(--white)] hover:bg-[var(--sell)]"
          >
            {loading ? <Spinner size="sm" /> : "Update"}
          </Button>

          <Button
            color="gray"
            onClick={() => setShowModal(false)}
            className="min-w-[100px]"
          >
            Cancel
          </Button>

          <Button
            onClick={handleRemove}
            disabled={loading}
            className="min-w-[100px] bg-[var(--sell)] text-[var(--white)] hover:bg-[var(--sell)]"
          >
            {loading ? <Spinner size="sm" /> : "Remove"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
